import { render, staticRenderFns } from "./VolumeDistributionChart.vue?vue&type=template&id=72cee27c"
import script from "./VolumeDistributionChart.vue?vue&type=script&lang=js"
export * from "./VolumeDistributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports